"use client";

import { AppBar, Box, Slide, Toolbar, Typography } from "@mui/material";
import { PropsWithChildren } from "react";
import { useNetworkState } from "react-use";

export default function NetworkCheckStatus() {
  const state = useNetworkState();
  const isSlowNetwork =
    state.effectiveType === "2g" ||
    state.effectiveType === "slow-2g" ||
    (state.downlink && state.downlink < 0.5) || // Downlink less than 0.5 Mbps
    (state.rtt && state.rtt > 300);
  if (state && state.online === false) {
    return (
      <AppBar
        component={"div"}
        position="fixed"
        color="error"
        sx={{
          top: 0,
          width: "max-content",
          left: "50%",
          px: 2,
          borderBottomLeftRadius: 12,
          borderBottomRightRadius: 12,
          py: 0.5,
          transform: "translateX(-50%) !important",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
      >
        <Typography variant="body2">اتصال اینترنت قطع است</Typography>
      </AppBar>
    );
  }
  // if (isSlowNetwork) {
  //   return (
  //     <AppBar
  //       component={"div"}
  //       position="absolute"
  //       color="warning"
  //       sx={{
  //         top: 0,
  //         width: "max-content",
  //         left: "50%",
  //         px: 2,
  //         borderBottomLeftRadius: 12,
  //         borderBottomRightRadius: 12,
  //         py: 0.5,
  //         transform: "translateX(-50%) !important",
  //         zIndex: (theme) => theme.zIndex.drawer + 1,
  //       }}
  //     >
  //       <Typography variant="body2">اتصال اینترنت وضعیف است</Typography>
  //     </AppBar>
  //   );
  // }
  return <></>;
}
